'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$190() {
  this.c2u = null;
  this.c2s = null;
  this.c2t = false;
  this.c2q = null;
  this.c2r = false;
  this.c2v = false;
  this.c2w = false;
  this.c2u = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$$anon$190 as $c_Lpresto_types$$anon$190 };
$p = $c_Lpresto_types$$anon$190.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$190;
/** @constructor */
function $h_Lpresto_types$$anon$190() {
}
export { $h_Lpresto_types$$anon$190 as $h_Lpresto_types$$anon$190 };
$h_Lpresto_types$$anon$190.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.c2u;
});
$p.t = (function() {
  if ((!this.c2t)) {
    this.c2s = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c2t = true;
  }
  return this.c2s;
});
$p.ae = (function() {
  if ((!this.c2r)) {
    this.c2q = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rq, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rq, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c2r = true;
  }
  return this.c2q;
});
$p.w = (function() {
  if ((!this.c2w)) {
    this.c2v = false;
    this.c2w = true;
  }
  return this.c2v;
});
$p.acz = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
$p.ac = (function(a) {
  return this.acz(a);
});
var $d_Lpresto_types$$anon$190 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$190, "presto.types$$anon$190", ({
  Y9: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$190 as $d_Lpresto_types$$anon$190 };
//# sourceMappingURL=presto.types$$anon$190.js.map
